import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { configureAuth } from './lib/auth.ts';
import { installGtag } from './lib/analytics.ts';
import './index.css';

// Configure Cognito + GA4 once before the app mounts. Both are no-ops when
// their respective env vars are missing (M5.1 scaffold case).
configureAuth();
installGtag();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
